/**
 * Catálogos operativos (cobranza, cumplimiento, expediente y mensajería).
 * Centralizan los valores que la base de datos guarda como texto o enum para
 * que el API y la web usen constantes con tipo en lugar de cadenas sueltas.
 */
import { keyedEnum } from './enum.js';
// ── Promesas de pago ────────────────────────────────────────────────────────
/** Estados de una promesa de pago registrada en una gestión de cobro. */
export const PROMISE_STATUSES = ['pending', 'kept', 'broken'];
/** Catálogo con clave: `PROMISE_STATUS.broken`. */
export const PROMISE_STATUS = keyedEnum(PROMISE_STATUSES);
/** Etiquetas en español de cada estado de promesa. */
export const PROMISE_STATUS_LABELS = {
    pending: 'Pendiente',
    kept: 'Cumplida',
    broken: 'Incumplida',
};
// ── Alertas de cumplimiento (IVE) ───────────────────────────────────────────
/** Severidades de una alerta de cumplimiento. */
export const ALERT_SEVERITIES = ['info', 'warning', 'critical'];
/** Catálogo con clave: `ALERT_SEVERITY.critical`. */
export const ALERT_SEVERITY = keyedEnum(ALERT_SEVERITIES);
/** Etiquetas en español de cada severidad. */
export const ALERT_SEVERITY_LABELS = {
    info: 'Informativa',
    warning: 'Advertencia',
    critical: 'Crítica',
};
/** Estados de una alerta: abierta, descartada tras revisión o reportada a la IVE. */
export const ALERT_STATUSES = ['open', 'dismissed', 'reported'];
/** Catálogo con clave: `ALERT_STATUS.open`. */
export const ALERT_STATUS = keyedEnum(ALERT_STATUSES);
/** Etiquetas en español de cada estado de alerta. */
export const ALERT_STATUS_LABELS = {
    open: 'Abierta',
    dismissed: 'Descartada',
    reported: 'Reportada a la IVE',
};
// ── Expediente digital: lectura automática (OCR) ────────────────────────────
/** Estados de la lectura automática de un documento. */
export const DOCUMENT_OCR_STATUSES = ['not_applicable', 'pending', 'completed', 'failed'];
/** Catálogo con clave: `DOCUMENT_OCR_STATUS.pending`. */
export const DOCUMENT_OCR_STATUS = keyedEnum(DOCUMENT_OCR_STATUSES);
/** Etiquetas en español de cada estado de OCR. */
export const DOCUMENT_OCR_STATUS_LABELS = {
    not_applicable: 'No aplica',
    pending: 'En proceso',
    completed: 'Leído',
    failed: 'No se pudo leer',
};
// ── Mensajes a clientes ─────────────────────────────────────────────────────
/** Canales por los que se envían mensajes a los clientes. */
export const CLIENT_MESSAGE_CHANNELS = ['whatsapp', 'sms'];
/** Catálogo con clave: `CLIENT_MESSAGE_CHANNEL.whatsapp`. */
export const CLIENT_MESSAGE_CHANNEL = keyedEnum(CLIENT_MESSAGE_CHANNELS);
/** Estados de un mensaje: en cola (la web ofrece el enlace wa.me), enviado o fallido. */
export const CLIENT_MESSAGE_STATUSES = ['queued', 'sent', 'failed'];
/** Catálogo con clave: `CLIENT_MESSAGE_STATUS.queued`. */
export const CLIENT_MESSAGE_STATUS = keyedEnum(CLIENT_MESSAGE_STATUSES);
/** Plantillas de mensaje a clientes. */
export const CLIENT_MESSAGE_TEMPLATES = ['installment_reminder', 'overdue_reminder'];
/** Catálogo con clave: `CLIENT_MESSAGE_TEMPLATE.installment_reminder`. */
export const CLIENT_MESSAGE_TEMPLATE = keyedEnum(CLIENT_MESSAGE_TEMPLATES);
// ── Pagos ───────────────────────────────────────────────────────────────────
/** Estados de un pago: vigente o reversado (anulado con su motivo). */
export const PAYMENT_STATUSES = ['posted', 'reversed'];
/** Catálogo con clave: `PAYMENT_STATUS.posted`. */
export const PAYMENT_STATUS = keyedEnum(PAYMENT_STATUSES);
/** Etiquetas en español de los estados de un pago (pantallas, recibos y CSV). */
export const PAYMENT_STATUS_LABELS = {
    posted: 'Vigente',
    reversed: 'Reversado',
};
//# sourceMappingURL=operations.js.map